import React from 'react';
import './NavigationHeader.css';

interface NavigationHeaderProps {
  levelName: string;
  onBackToLevels: () => void;
}

const NavigationHeader: React.FC<NavigationHeaderProps> = ({ levelName, onBackToLevels }) => {
  return (
    <header className="navigation-header">
      <button 
        className="nav-back-btn"
        onClick={onBackToLevels}
        title="Back to Level Selection"
      >
        ← Back to Sites
      </button>
      
      <div className="level-title">
        <h2>{levelName}</h2>
        <p className="level-subtitle">Archaeological Restoration</p>
      </div>
      
      <div className="nav-spacer"></div>
    </header>
  );
};

export default NavigationHeader;